import React from 'react';
import Lottie from 'react-lottie';
import comming from '../../assets/images/comming.json'
const Comming = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: comming,
       
      };
    return (
        <div className='flex items-center justify-center h-screen'>
           
<Lottie

options={defaultOptions}

width={500}

/>


        </div>
    );
};

export default Comming;